// [BD feat] PDP Buy Box — sold-out sync + header price mirror + mobile gallery scrollbar
// Progressive enhancement only: keeps the add-to-cart button in sync with the
// currently-selected variant's availability, and mirrors Wonder's #price-…
// updates into the Figma header price under the title.
(function () {
  'use strict';

  var root = document.querySelector('.bd-pdp-buy-box');
  if (!root) return;

  var isMobileMq = window.matchMedia('(max-width: 899.98px)');

  /* ---- Mobile gallery progress bar (Figma 890:13400) ----
     Swiper often initializes before square slide height settles, leaving
     .swiper-scrollbar-drag at width:0. Re-measure after layout / init race. */
  function getGallerySection() {
    return root.querySelector('gallery-section');
  }

  function refreshGalleryScrollbar() {
    if (!isMobileMq.matches) return;
    var section = getGallerySection();
    if (!section) return;
    var swiper = section.gallerySwiper;
    if (!swiper) return;
    try {
      /* Full-bleed slides — Figma image is edge-to-edge in the frame */
      if (swiper.params.spaceBetween !== 0) swiper.params.spaceBetween = 0;
      if (swiper.params.slidesPerView !== 1) swiper.params.slidesPerView = 1;
      swiper.update();
      if (swiper.scrollbar && typeof swiper.scrollbar.updateSize === 'function') {
        swiper.scrollbar.updateSize();
      }
    } catch (err) {
      /* ignore — gallery may still be mounting */
    }
  }

  function scheduleGalleryRefresh() {
    window.requestAnimationFrame(function () {
      refreshGalleryScrollbar();
      window.setTimeout(refreshGalleryScrollbar, 50);
      window.setTimeout(refreshGalleryScrollbar, 200);
      window.setTimeout(refreshGalleryScrollbar, 600);
    });
  }

  /* Poll until gallerySwiper exists (gallery.js is also defer — race with us). */
  function waitForGalleryAndRefresh() {
    var attempts = 0;
    function tick() {
      var section = getGallerySection();
      if (section && section.gallerySwiper) {
        scheduleGalleryRefresh();
        bindGalleryListeners(section);
        return;
      }
      if (++attempts < 50) window.setTimeout(tick, 100);
    }
    tick();
  }

  var galleryBound = false;
  function bindGalleryListeners(section) {
    if (galleryBound) return;
    var swiper = section.gallerySwiper;
    if (!swiper) return;
    galleryBound = true;
    swiper.on('slideChange', refreshGalleryScrollbar);
    swiper.on('slideChangeTransitionEnd', refreshGalleryScrollbar);
    swiper.on('resize', refreshGalleryScrollbar);
    swiper.on('imagesReady', refreshGalleryScrollbar);
    swiper.on('update', function () {
      if (!isMobileMq.matches) return;
      if (swiper.scrollbar && typeof swiper.scrollbar.updateSize === 'function') {
        try {
          swiper.scrollbar.updateSize();
        } catch (err) {
          /* ignore */
        }
      }
    });

    var galleryEl = section.querySelector('[data-gallery]');
    if (galleryEl && typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(function () {
        refreshGalleryScrollbar();
      });
      ro.observe(galleryEl);
    }

    galleryEl &&
      galleryEl.querySelectorAll('img').forEach(function (img) {
        if (!img.complete) {
          img.addEventListener('load', refreshGalleryScrollbar, { once: true });
        }
      });
  }

  waitForGalleryAndRefresh();
  window.addEventListener('load', scheduleGalleryRefresh);
  window.addEventListener('resize', function () {
    window.setTimeout(refreshGalleryScrollbar, 150);
  });
  if (typeof isMobileMq.addEventListener === 'function') {
    isMobileMq.addEventListener('change', scheduleGalleryRefresh);
  } else if (typeof isMobileMq.addListener === 'function') {
    isMobileMq.addListener(scheduleGalleryRefresh);
  }
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.bd-pdp-buy-box')) {
      galleryBound = false;
      waitForGalleryAndRefresh();
    }
  });

  /* ---- Header price mirror (Figma 976:24778: title → price → one-liner) ----
     Wonder variants.js + subscription-widget update #price-…; we mirror that into
     [data-bd-header-price]. Re-query the source every time — Recharge can replace
     the #price node and invalidate a one-shot MutationObserver target. */
  function getPriceSource() {
    return (
      root.querySelector('.bd-pdp-buy-box__price-source .price') ||
      root.querySelector('[id^="price-"] .price') ||
      root.querySelector('.bd-pdp-buy-box__price-source') ||
      root.querySelector('[id^="price-"]')
    );
  }

  function syncHeaderPrice() {
    var source = getPriceSource();
    var target = root.querySelector('[data-bd-header-price]');
    if (!source || !target) return;

    var html =
      source.classList && source.classList.contains('price')
        ? source.outerHTML
        : source.querySelector('.price')
          ? source.querySelector('.price').outerHTML
          : source.innerHTML;

    if (!html || target.innerHTML === html) return;
    target.innerHTML = html;
  }

  function scheduleHeaderPriceSync() {
    syncHeaderPrice();
    window.requestAnimationFrame(syncHeaderPrice);
    window.setTimeout(syncHeaderPrice, 0);
    window.setTimeout(syncHeaderPrice, 50);
    window.setTimeout(syncHeaderPrice, 200);
  }

  syncHeaderPrice();

  var priceObserver = null;
  function observePriceSource() {
    if (!('MutationObserver' in window)) return;
    var priceSource =
      root.querySelector('.bd-pdp-buy-box__price-source') ||
      root.querySelector('[id^="price-"]');
    if (!priceSource) return;
    if (priceObserver) priceObserver.disconnect();
    priceObserver = new MutationObserver(function () {
      syncHeaderPrice();
    });
    priceObserver.observe(priceSource, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
    });
  }

  observePriceSource();

  /* Wonder publishes after #price-… is patched */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      scheduleHeaderPriceSync();
      observePriceSource();
    });
  }

  document.addEventListener('variantChangeEnd', function (e) {
    if (e.target && !root.contains(e.target)) return;
    scheduleHeaderPriceSync();
    observePriceSource();
  });

  /* ---- Sold-out state sync ---- */
  var dataEl = root.querySelector('[data-bd-variant-availability]');
  if (!dataEl) {
    /* Still keep price mirror hooks above even when ATC map is missing */
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector && e.target.querySelector('.bd-pdp-buy-box')) {
        syncHeaderPrice();
        observePriceSource();
      }
    });
    return;
  }

  var availability;
  try {
    availability = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  if (!availability || typeof availability !== 'object') return;

  var soldOutLabel = dataEl.getAttribute('data-sold-out-label') || 'Sold out';
  var addLabel = dataEl.getAttribute('data-add-label') || 'Add to cart';

  var form =
    root.querySelector('form[data-type="add-to-cart-form"]') ||
    root.querySelector('.wt-product__add-to-cart_form');
  if (!form) return;

  function getIdInput() {
    return form.querySelector('input[name="id"]');
  }
  function getButton() {
    return form.querySelector('.product-form__submit');
  }

  var syncing = false;

  function sync() {
    if (syncing) return;
    var idInput = getIdInput();
    var btn = getButton();
    if (!idInput || !btn) return;

    var id = String(idInput.value || '');
    var isAvailable = availability[id];
    if (typeof isAvailable === 'undefined') return;

    var labelEl = btn.querySelector('span');
    syncing = true;

    if (isAvailable === false) {
      if (!btn.disabled) btn.disabled = true;
      if (btn.getAttribute('aria-disabled') !== 'true') btn.setAttribute('aria-disabled', 'true');
      if (labelEl && labelEl.textContent.trim() !== soldOutLabel) labelEl.textContent = soldOutLabel;
    } else if (isAvailable === true) {
      if (btn.disabled) btn.disabled = false;
      if (btn.hasAttribute('aria-disabled')) btn.removeAttribute('aria-disabled');
      if (labelEl && labelEl.textContent.trim() === soldOutLabel) labelEl.textContent = addLabel;
    }

    window.requestAnimationFrame(function () {
      syncing = false;
    });
  }

  sync();

  form.addEventListener('change', function () {
    window.setTimeout(function () {
      sync();
      scheduleHeaderPriceSync();
    }, 0);
  });

  if ('MutationObserver' in window) {
    var observer = new MutationObserver(function () {
      if (syncing) return;
      sync();
    });
    observer.observe(form, { childList: true, subtree: true, attributes: true });
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.bd-pdp-buy-box')) {
      sync();
      scheduleHeaderPriceSync();
      observePriceSource();
    }
  });
})();
// [BD feat] PDP Buy Box
